import Vue from 'vue'

Vue.filter('dateformat', (value) => {
  if (!value) return ''
  var d = new Date(value * 1000)
  return d.toLocaleDateString('de-DE', {weekday: 'long', day: '2-digit', month: '2-digit', year: 'numeric'})
})

Vue.filter('dateformatshort', (value) => {
  if (!value) return ''
  var d = new Date(value * 1000)
  return d.toLocaleDateString('de-DE', {day: '2-digit', month: '2-digit', year: '2-digit', hour: '2-digit', minute: '2-digit'})
})



// WEBPACK FOOTER //
// ./src/filter/filters.js